import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  isLoading = false,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "#ff6b35",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px", fontFamily: "Karbon" } }}
    >
      <DialogTitle sx={{ bgcolor: "#fef5f1", pb: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            color="#666666"
            fontWeight={600}
            fontFamily="Karbon"
          >
            {title}
          </Typography>
          <IconButton
            onClick={onCancel}
            size="small"
            sx={{ color: "#666666" }}
            disabled={isLoading}
          >
            <i className="bi bi-x-lg"></i>
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ bgcolor: "#fff", py: 3 }}>
        <Typography
          color="#666666"
          sx={{ lineHeight: 1.6 }}
          fontFamily="Karbon"
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2, bgcolor: "#fef5f1" }}>
        <Button
          onClick={onCancel}
          disabled={isLoading}
          sx={{
            color: "#666666",
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "8px",
            px: 3,
            fontFamily: "Karbon",
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isLoading}
          sx={{
            bgcolor: confirmColor,
            color: "#fff",
            textTransform: "none",
            borderRadius: "8px",
            px: 3,
            fontWeight: 600,
            fontFamily: "Karbon",
            "&:hover": {
              bgcolor: confirmColor === "#d32f2f" ? "#c62828" : confirmColor,
            },
            "&:disabled": {
              bgcolor: "#e0e0e0",
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
